export const PLAN_CATALOG = [
  { name: "Free", m: 0, y: 0, desc: "Explore the platform and run your first campaign.",
    features: ["10 creator searches / mo", "Campaigns & creator CRM", "Basic analytics", "1 seat"] },
  { name: "Starter", m: 99, y: 79, credits: 1000, packBonus: 0,
    desc: "Essential discovery for focused teams.",
    features: ["500 creator searches / mo", "5 active campaigns", "Audience quality insights", "AI Creative Studio", "1,000 Studio credits / mo", "1 seat"] },
  { name: "Growth", m: 249, y: 199, credits: 2500, packBonus: 10, popular: true,
    desc: "A complete creator engine for scaling brands.",
    features: ["2,500 creator searches / mo", "20 active campaigns", "AI briefs, matching & outreach", "Social listening", "AI Creative Studio", "2,500 Studio credits / mo", "5 seats"] },
  { name: "Scale", m: 599, y: 479, credits: 6000, packBonus: 20,
    desc: "High-volume operations with deeper intelligence.",
    features: ["10,000 creator searches / mo", "Unlimited campaigns", "EMV & portfolio reporting", "AI Creative Studio", "6,000 Studio credits / mo", "15 seats"] },
  { name: "Enterprise", m: null, y: null, packBonus: 25, enterprise: true,
    desc: "Tailored infrastructure for complex organizations.",
    features: ["Unlimited searches", "Custom Studio credit allowance", "Multiple client workspaces", "Custom permissions & API", "Dedicated strategy support"] },
];

export const PLAN_ORDER = ["Free", "Starter", "Growth", "Scale", "Enterprise"];

export const studioNote = (name, discounts) => {
  if (!discounts || discounts[name] == null) return null;
  return discounts[name] > 0 ? `Studio generations ${discounts[name]}% cheaper` : "Standard Studio prices";
};

export const CREDIT_VALUE_NOTE = "1 credit = $0.10 of Studio usage. Included credits are added each month and roll over.";
